import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0px 20px 20px 20px;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
